export default "__VITE_ASSET__f12aeb4c__"